import { Table } from "@/widgets/Table";
import type { MappedStuck } from "../../types";
import { HEADERS } from "@/modules/Dashboard/constants/metrics";
import { StuckRow } from "./StuckRow";

interface StucksViewProps {
  stucks: MappedStuck[];
}

export function StucksView({ stucks }: StucksViewProps) {
  return (
    <Table columns={HEADERS} emptyMessage="Данные по склейкам отсутствуют">
      {stucks.map((stuck, index) => (
        <StuckRow key={stuck.id} stuck={stuck} index={index} />
      ))}
    </Table>
  );
}
